import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'

import { Col, Row } from 'react-bootstrap'
import ButtonBar from '../../containers/ButtonBar'
import ViewButton from '../../components/ViewButton'
import ModifyQuery from '../../components/ModifyQuery'
import { sync } from '../../stores'

@observer
class TopBar extends Component {
  constructor(props) {
    super(props)
    this.viewHandler = this.viewHandler.bind(this)
    this.queryHandler = this.queryHandler.bind(this)
  }

  viewHandler(displayMode) {
    this.props.store.setDisplayMode(displayMode)
  }
  queryHandler(newQuery) {
    this.props.store.query.setTerm(newQuery.term)
    // Force a sync in case the autosync doesn't fire before
    // the browser has left.
    sync(this.props.store)
  }

  render() {
    const { store } = this.props

    return (
      <Row>
        <Col xs={7} md={3} style={{ marginTop: 20 }}>
          {store.query && store.query.caller === 'simple' && (
            <ModifyQuery query={store.query} onChange={this.queryHandler} />
          )}
        </Col>
        <Col xs={5} md={3} mdPush={4}>
          <ViewButton
            displayMode={store.displayMode}
            onClick={this.viewHandler}
            disableTable={!store.isUniform}
          />
        </Col>
        <Col xs={12} md={4} mdPull={3} style={{ marginTop: 20 }}>
          <ButtonBar
            ids={store.filteredSelectedIds}
            dataClasses={store.dataClasses}
            dataClassLabels={store.itemStore.dataClassLabels}
          />
        </Col>
      </Row>
    )
  }
}

TopBar.propTypes = {
  store: PropTypes.object.isRequired,
}

export default TopBar
